// Card preview configuration values

// Base dimensions
export const BASE_CONTAINER_WIDTH = 440;

// Card dimensions for placeholder
export const DEFAULT_CARD_WIDTH = 108;
export const DEFAULT_CARD_HEIGHT = 128;

// Responsive preview height calculation
export const DESKTOP_HEIGHT_RATIO = 0.32; // 32% of viewport width
export const MIN_PREVIEW_HEIGHT = 224;
export const MAX_PREVIEW_HEIGHT = 535;
export const MOBILE_PREVIEW_HEIGHT = 224;
export const DESKTOP_WIDTH = 1024;

// Portrait and landscape limits
export const MAX_LARGE_DIMENSION = 3;
export const MAX_SMALL_DIMENSION = 2;
export const MIN_ASPECT_RATIO = MAX_SMALL_DIMENSION / MAX_LARGE_DIMENSION;
export const MAX_ASPECT_RATIO = MAX_LARGE_DIMENSION / MAX_SMALL_DIMENSION;

// Default card height percentages
export const PORTRAIT_CARD_HEIGHT_PERCENTAGE = 85; // 85%
export const LANDSCAPE_MIN_PERCENTAGE = 60; // Minimum percentage at larger widths
export const LANDSCAPE_MAX_PERCENTAGE = 70; // Maximum percentage at smaller widths
export const LANDSCAPE_MIN_WIDTH = 440; // Width at which we use MAX_PERCENTAGE
export const LANDSCAPE_MAX_WIDTH = 570; // Width at which we use MIN_PERCENTAGE

// Padding values for card
export const DESKTOP_TOP_PADDING = 32;
export const DESKTOP_BOTTOM_PADDING = 64;
export const DESKTOP_SIDE_PADDING = 32;
export const MOBILE_TOP_PADDING = 16;
export const MOBILE_BOTTOM_PADDING = 32;
export const MOBILE_SIDE_PADDING = 16;

// Animation defaults
export const DEFAULT_ANIMATION_DURATION = 400; // Slightly longer for smoother animations
export const DEFAULT_TIMING_FUNCTION = "cubic-bezier(0.4, 0.0, 0.2, 1)"; // Material design standard easing

// Animation values for card transforms
export const CARD_ROTATION = 15; // Degrees rotation during back card flip

// Mobile card offsets
export const PORTRAIT_CARD_OFFSET_X = 7; // Horizontal offset for portrait mode
export const PORTRAIT_CARD_OFFSET_Y = 4; // Vertical offset for portrait mode
export const LANDSCAPE_CARD_OFFSET_X = 7; // Horizontal offset for landscape mode
export const LANDSCAPE_CARD_OFFSET_Y = 4; // Vertical offset for landscape mode

// Desktop card offsets
export const DESKTOP_PORTRAIT_CARD_OFFSET_X = 15; // Horizontal offset for desktop portrait
export const DESKTOP_PORTRAIT_CARD_OFFSET_Y = 3.5; // Vertical offset for desktop portrait
export const DESKTOP_LANDSCAPE_CARD_OFFSET_X = 19; // Horizontal offset for desktop landscape
export const DESKTOP_LANDSCAPE_CARD_OFFSET_Y = 4; // Vertical offset for desktop landscape

// Card sent animation offsets
export const PORTRAIT_FRONT_CARD_SENT_OFFSET_X = 18; // Front card offset for portrait
export const LANDSCAPE_FRONT_CARD_SENT_OFFSET_X = 14; // Front card offset for landscape
export const PORTRAIT_BACK_CARD_SENT_OFFSET_X = 30; // Back card offset for portrait
export const LANDSCAPE_BACK_CARD_SENT_OFFSET_X = 38; // Back card offset for landscape

// Desktop card sent animation offsets
export const DESKTOP_PORTRAIT_FRONT_CARD_SENT_OFFSET_X = 19; // Front card offset for portrait
export const DESKTOP_LANDSCAPE_FRONT_CARD_SENT_OFFSET_X = 16; // Front card offset for landscape
export const DESKTOP_PORTRAIT_BACK_CARD_SENT_OFFSET_X = 30; // Back card offset for portrait
export const DESKTOP_LANDSCAPE_BACK_CARD_SENT_OFFSET_X = 33; // Back card offset for landscape

// Whoosh animation values
export const LANDSCAPE_WHOOSH_FINAL_X = -15; // Final position (landscape)
export const PORTRAIT_WHOOSH_FINAL_X = -6; // Final position (portrait)
export const LANDSCAPE_WHOOSH_INITIAL_X = -20; // Initial position (landscape)
export const PORTRAIT_WHOOSH_INITIAL_X = -10; // Initial position (portrait)
export const WHOOSH_SCALE = 1; // Scale for whoosh animation
export const DESKTOP_LANDSCAPE_WHOOSH_FINAL_X = -10; // Final position (desktop landscape)
export const DESKTOP_PORTRAIT_WHOOSH_FINAL_X = -6.5; // Final position (desktop portrait)
export const DESKTOP_LANDSCAPE_WHOOSH_INITIAL_X = -20; // Initial position (desktop landscape)
export const DESKTOP_PORTRAIT_WHOOSH_INITIAL_X = -10; // Initial position (desktop portrait)
export const DESKTOP_WHOOSH_SCALE = 1.25; // Scale for desktop whoosh animation

// Animation duration multipliers
export const BACK_CARD_RETURN_DURATION_MULTIPLIER = 1.8; // Slightly faster for smoother transitions
export const FRONT_CARD_SENT_DURATION_MULTIPLIER = 2.0; // Slightly faster for smoother transitions
export const CONFETTI_DURATION_MULTIPLIER = 1.5; // Slightly faster confetti
export const ANIMATION_COMPLETE_DURATION_MULTIPLIER = 4.0; // Slightly shorter overall duration
